import { useClient } from '../../../../react-hooks/useClient';
import { mapChoicesToOptions, sortFieldOptions } from '../utils/fieldOptions';

export async function fetchLandingPageImageFieldOptions({
    id,
    modelId = 'cms/landing-page-layout',
} = {}) {
    const client = useClient();

    if (!client || !id) {
        return sortFieldOptions([]);
    }

    try {
        const response = await client.post('form/config/cms/landing-page-image', {
            contextObj: {
                id,
                modelId,
            },
        });

        const formFields = response?.data?.fields || [];
        const propertyField = formFields.find(
            (field) => field?.property === 'property'
        );

        return mapChoicesToOptions(propertyField?.choices || []);
    } catch (error) {
        console.error(
            '[landingPageImageFields] Failed to load field options',
            error
        );
        return sortFieldOptions([]);
    }
}
